export var ButtonMode;
(function (ButtonMode) {
    ButtonMode["Primary"] = "primary";
    ButtonMode["Secondary"] = "secondary";
    ButtonMode["Tertiary"] = "tertiary";
    ButtonMode["Link"] = "link";
})(ButtonMode || (ButtonMode = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["Button"] = "button";
    ButtonType["Reset"] = "reset";
    ButtonType["Submit"] = "submit";
})(ButtonType || (ButtonType = {}));
export var ButtonSlot;
(function (ButtonSlot) {
    ButtonSlot["IconOnly"] = "icon-only";
    ButtonSlot["Start"] = "start";
    ButtonSlot["End"] = "end";
})(ButtonSlot || (ButtonSlot = {}));
export var ButtonTagType;
(function (ButtonTagType) {
    ButtonTagType["Button"] = "button";
    ButtonTagType["Link"] = "a";
})(ButtonTagType || (ButtonTagType = {}));
export var ButtonVRTState;
(function (ButtonVRTState) {
    ButtonVRTState["Hover"] = "hover";
    ButtonVRTState["Focus"] = "focus";
    ButtonVRTState["Active"] = "active";
})(ButtonVRTState || (ButtonVRTState = {}));
export var ButtonCssClass;
(function (ButtonCssClass) {
    ButtonCssClass["Base"] = "iress-button";
    ButtonCssClass["Primary"] = "iress-button--primary";
    ButtonCssClass["Secondary"] = "iress-button--secondary";
    ButtonCssClass["Tertiary"] = "iress-button--tertiary";
    ButtonCssClass["Link"] = "iress-button--link";
    ButtonCssClass["Fluid"] = "iress-button--fluid";
    ButtonCssClass["Button"] = "iress-button__button";
    ButtonCssClass["Inner"] = "iress-button__inner";
    ButtonCssClass["Hover"] = "iress-button--hover";
    ButtonCssClass["Focus"] = "iress-button--focus";
    ButtonCssClass["Active"] = "iress-button--active";
})(ButtonCssClass || (ButtonCssClass = {}));
//# sourceMappingURL=button.types.js.map